import React from 'react'
import { Box, Typography, Paper, Button, Divider, Alert } from '@mui/material'
import { Google as GoogleIcon, LockOutlined as LockIcon, Security as SecurityIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useCustomerAuth } from '@/context/CustomerAuthContext'
import CustomerLayout from '@/components/Layout/CustomerLayout'

export const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const { isLoggedIn, loginWithGoogle, user } = useCustomerAuth()

  const handleGoogleLogin = () => {
    loginWithGoogle()
    navigate('/checkout')
  }

  return (
    <CustomerLayout>
      <Box sx={{ maxW: 480, mx: 'auto', py: 4 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: 3, textAlign: 'center', bgcolor: '#ffffff' }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              bgcolor: '#eff6ff',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2,
            }}
          >
            <LockIcon sx={{ fontSize: 32 }} />
          </Box>

          <Typography variant="h5" fontWeight={700} gutterBottom>
            ログイン / アカウント作成
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            HighLandirect オンライン注文システムへようこそ。<br />
            Googleアカウントで安全かつ簡単にログインいただけます。
          </Typography>

          {isLoggedIn && user ? (
            <Alert severity="success" sx={{ mb: 3, textAlign: 'left' }}>
              現在 <strong>{user.Name}</strong> ({user.Email}) としてログイン中です。
              <Button size="small" onClick={() => navigate('/checkout')} sx={{ mt: 1, display: 'block' }}>
                注文手続きへ進む
              </Button>
            </Alert>
          ) : null}

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleGoogleLogin}
            startIcon={<GoogleIcon />}
            sx={{
              py: 1.5,
              bgcolor: '#ffffff',
              color: '#3c4043',
              border: '1px solid #dadce0',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              fontWeight: 600,
              fontSize: '1rem',
              textTransform: 'none',
              '&:hover': {
                bgcolor: '#f8f9fa',
                borderColor: '#d2e3fc',
                boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
              },
              mb: 3,
            }}
          >
            Google アカウントでログイン
          </Button>

          <Divider sx={{ my: 2 }}>
            <Typography variant="caption" color="text.secondary">
              セキュリティ & 個人の安全
            </Typography>
          </Divider>

          <Box sx={{ display: 'flex', alignItems: 'center', justify: 'center', gap: 1, color: '#64748b' }}>
            <SecurityIcon fontSize="small" />
            <Typography variant="caption">
              パスワード管理不要。Google OAuth 2.0 で安全に認証されます。
            </Typography>
          </Box>
        </Paper>
      </Box>
    </CustomerLayout>
  )
}
export default LoginPage
